import { createStyles, makeStyles } from '@material-ui/core'

import { theme } from './mui'

const useStyles = makeStyles(() =>
  createStyles({
    '@global': {
      '*': {
        boxSizing: 'border-box',
        margin: 0,
        padding: 0,
      },
      html: {
        '-webkit-font-smoothing': 'antialiased',
        '-moz-osx-font-smoothing': 'grayscale',
        height: '100%',
        width: '100%',
      },
      body: {
        height: '100%',
        width: '100%',
        backgroundColor: theme.colors.bgColor,
        fontFamily: 'Effra, sans-serif',
      },
      'input, select': {
        fontFamily: 'Effra, sans-serif',
      },
      a: {
        textDecoration: 'none',
        color: '#00837d',
      },
      '#root': {
        height: '100%',
        width: '100%',
      },
      '.l-pageHeader': {
        display: 'flex',
        '& > a': {
          marginLeft: 15,
        },
      },
      '.l-richText': {
        whiteSpace: 'pre-wrap',
      },
      '.MuiFormLabel-root': {
        position: 'relative',
        transform: 'none!important',
        fontSize: '14px',
        fontWeight: 500,
        letterSpacing: '-0.2px',
        lineHeight: '22px',
        color: `${theme.colors.grey600}!important`,
        marginBottom: 6,
        display: 'inline-block',
      },
      '.l-fieldWrapper': {
        marginBottom: theme.spacing(2.5),
        '& .l-labelFieldWrapper': {
          flexShrink: 0,
          marginTop: 4,
          '& label': {
            color: theme.colors.grey600,
            fontWeight: 500,
            fontSize: 14,
          },
        },
        '& .MuiFormControl-root': {
          marginBottom: 0,
        },
      },
      '.l-fieldWrapper--withButton': {
        display: 'flex',
        '& .l-textFieldWrapper': {
          width: '100%',
        },
        '& button': {
          alignSelf: 'flex-end',
          marginLeft: theme.spacing(1.25),
          [theme.breakpoints.down('xs')]: {
            marginTop: 15,
          },
        },
        [theme.breakpoints.down('xs')]: {
          flexDirection: 'column',
        },
      },
      '.l-fieldWrapper--horizontal': {
        display: 'flex',
        alignItems: 'flex-start',
        paddingTop: 20,
        paddingBottom: 20,
        boxShadow: 'inset 0 1px 0 0 #EBEBEB, inset 0 -1px 0 0 #EBEBEB',
        '& .l-labelFieldWrapper': {
          width: 322,
          flexShrink: 0,
          marginTop: 4,
          '& label': {
            color: theme.colors.grey600,
            fontWeight: 500,
            fontSize: 14,
          },
        },
        [theme.breakpoints.down('sm')]: {
          flexDirection: 'column',
          alignItems: 'flex-start',
          '& .l-labelFieldWrapper': {
            marginBottom: theme.spacing(1.25),
          },
        },
        '& .l-textFieldWrapper': {
          width: '100%',
          marginBottom: 0,
        },
        '& .MuiTextField-root': {
          marginBottom: '0!important',
        },
      },
      '.l-fieldWrapper--locked': {
        '& .l-labelFieldWrapper, & .MuiFormLabel-root, & .MuiFormLabel-root': {
          position: 'relative',
          paddingLeft: 20,
          color: `${theme.colors.grey450}!important`,
          '&:before': {
            content: '""',
            backgroundImage: 'url("assets/icons/locked.svg")',
            backgroundRepeat: 'no-repeat',
            backgroundSize: 14,
            position: 'absolute',
            top: 2.5,
            left: 0,
            width: 16,
            height: 16,
          },
          '& label': {
            color: `${theme.colors.grey450}!important`,
          },
        },
        '& .c-richTextEditorWrapper, & .MuiInputBase-root, & .MuiButtonBase-root, & .c-select':
          {
            opacity: 0.5,
            pointerEvents: 'none',
          },
      },
      '.l-fieldGroupHeader': {
        marginTop: 20,
        '& h4': {
          color: '#000433',
          marginBottom: 15,
        },
      },
      '.h-noRatingChange': {
        color: 'AEB6C1',
      },
      '.h-positiveRatingChange': {
        color: '#00837D',
      },
      '.h-negativeRatingChange': {
        color: '#C00000',
      },
      '.l-chartWrapper': {
        width: '100%',
        height: 400,
      },
      '.l-chartContainer__additionalBottomText': {
        marginTop: 10,
      },
      '.l-chart__selectFilterWrapper': {
        width: 200,
      },
      '.l-chart__tooltipTitle': {
        color: theme.colors.white,
        marginBottom: 6,
        fontSize: theme.typography.pxToRem(14),
        lineHeight: theme.typography.pxToRem(18),
      },
      '.l-chartWrapper--scrollable': {
        overflowX: 'hidden',
      },
      '.h-chartFullWidth': {
        width: '100%!important',
        maxWidth: '100%',
        flexBasis: '100%',
      },
      '.l-noRecords': {
        width: '100%',
        height: 100,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontWeight: 500,
      },
      '.l-errorMessage': {
        fontWeight: 500,
        color: theme.colors.red,
        margin: '20px 0',
      },
      '.h-highlight': {
        fontWeight: 500,
        color: theme.colors.primary,
        backgroundColor: 'inherit',
      },
      '.h-exportableDataTitle': {
        display: 'flex',
        alignItems: 'flex-start',
        '& h3': {
          marginRight: 10,
        },
      },
      '.l-center': {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      },
      '.c-tooltipContent': {
        '& h2': {
          marginBottom: 15,
          fontSize: 18,
          lineHeight: '24px',
        },
        '& h3': {
          marginTop: 15,
          marginBottom: 7,
          fontSize: 13,
        },
        '& p': {},
      },
      '.c-tooltipContent--dark': {
        '& h2': {
          color: theme.colors.white,
        },
        '& h3': {
          color: theme.colors.primary,
        },
        '& p': {
          color: `#000433 !important`,
        },
      },
      '.MuiFormLabel-asterisk': {
        color: `${theme.colors.red}!important`,
      },
      '@keyframes spin': {
        '0%': {
          transform: 'rotate(0deg)',
        },
        '100%': {
          transform: 'rotate(360deg)',
        },
      },
    },
  }),
)

export const GlobalStyles = () => {
  useStyles()

  return null
}
